'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type UsersRoundProps = IconProps<keyof typeof animations>;
const animations = {
  default: {
    path1: {
      initial: {
        y: 0
      },
      animate: {
        y: [0, 4, -2, 0],
        transition: {
          duration: 0.6,
          ease: 'easeInOut',
          delay: 0.1
        }
      }
    },
    path2: {
      initial: {
        y: 0
      },
      animate: {
        y: [0, 1, -2, 0],
        transition: {
          duration: 0.6,
          ease: 'easeInOut'
        }
      }
    },
    path3: {
      initial: {
        y: 0
      },
      animate: {
        y: [0, 4, -2, 0],
        transition: {
          duration: 0.6,
          ease: 'easeInOut'
        }
      }
    },
    circle: {
      initial: {
        y: 0
      },
      animate: {
        y: [0, 1, -2, 0],
        transition: {
          duration: 0.6,
          ease: 'easeInOut',
          delay: 0.1
        }
      }
    }
  } satisfies Record<string, Variants>,
  appear: {
    path1: {},
    path2: {
      initial: {
        x: -5,
        opacity: 0
      },
      animate: {
        x: 0,
        opacity: 1,
        transition: {
          type: 'spring',
          stiffness: 100,
          damping: 10
        }
      }
    },
    path3: {
      initial: {
        x: -5,
        opacity: 0
      },
      animate: {
        x: 0,
        opacity: 1,
        transition: {
          type: 'spring',
          stiffness: 100,
          damping: 10
        }
      }
    },
    circle: {}
  } satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(16);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[4] !== controls) {
    t2 = <motion.path d="M18,21c0-4.4-3.6-8-8-8s-8,3.6-8,8" variants={variants.path1} initial="initial" animate={controls} />;
    t3 = <motion.path d="M18,12c2.2-1.7,2.7-4.8,1-7-.4-.5-.9-1-1.4-1.3" variants={variants.path2} initial="initial" animate={controls} />;
    t4 = <motion.path d="M22,20c0-3.4-2-6.5-4-8" variants={variants.path3} initial="initial" animate={controls} />;
    t5 = <motion.circle cx={10} cy={8} r={5} variants={variants.circle} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== size || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>{t2}{t3}{t4}{t5}</motion.svg>;
    $[9] = props;
    $[10] = size;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function UsersRound(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, UsersRound, UsersRound as UsersRoundIcon, type UsersRoundProps, type UsersRoundProps as UsersRoundIconProps };